import { createTypes } from "../../../utils/redux/create-types";

export default createTypes(
    `
    SCRIPT_LOADED
`,
    {
        prefix: "scriptsloader/"
    }
);
